// Returns a promise that resolves after 'ms' milliseconds
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
export const timeout = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
// Fetches data with a timeout. If the fetch doesn't complete within 'timeoutMs', returns null.
export const fetchDataWithTimeout = function() {
    var _ref = _async_to_generator(function*(fetchPromise, timeoutMs) {
        const response = yield Promise.race([
            fetchPromise,
            timeout(timeoutMs).then(()=>null)
        ]);
        if (!response) {
            return null;
        }
        return response;
    });
    return function fetchDataWithTimeout(fetchPromise, timeoutMs) {
        return _ref.apply(this, arguments);
    };
}();
export const fetchWithRetry = function() {
    var _ref = _async_to_generator(function*(url, options = {}, retries = 2, delay = 200) {
        let lastError;
        for(let i = 0; i <= retries; i++){
            try {
                const result = yield fetch(url, options);
                if (result instanceof Response) {
                    if (result.ok) {
                        return result;
                    }
                    throw new Error(`Fetch failed. Status: ${result.status}, StatusText: ${result.statusText}`);
                }
                throw new Error('Fetch did not return a successful Response');
            } catch (err) {
                lastError = err;
                if (i < retries) {
                    yield timeout(delay * Math.pow(2, i));
                }
            }
        }
        throw lastError;
    });
    return function fetchWithRetry(url) {
        return _ref.apply(this, arguments);
    };
}();
